import api from './api';

export default async function selectedTasksData(selectedIds, module) {
    const { data } = await api.post('export-tasks', {
            taskIds: selectedIds
        });
    return data;
}